'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    var adminOrderDetailMain = document.getElementById('adminOrderDetail');
    var saveButton = document.getElementById('adminOrderDetailSaveButton');

    if (!adminOrderDetailMain || !saveButton) {
        return;
    }

    saveButton.addEventListener('click', save);

    function save() {
        try {
            var orderIdElement = document.getElementById('orderIdHidden');
            if (!orderIdElement) return;

            var postData = {
                OrderId: orderIdElement.value,
                OrderState: getElementIntValueSafe('#stateValueCell>select'),
                InHegEvidence: getElementValueSafe('input[type=hidden][name=InHegEvidence]') === 'true'
            };

            var paymentRows = document.querySelectorAll('.order-payment-row');
            if (paymentRows.length > 0) {
                postData.Payments = [];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = paymentRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var row = _step.value;

                        var paymentId = getElementIntValueSafe('.hidden-payment-id', 'value', row);
                        if (!paymentId || paymentId < 1) continue;

                        var state = getElementIntValueSafe('td.dropdown-wrapper select', 'value', row);
                        var isActive = getElementValueSafe('td.check-box-wrapper input[type=checkbox]', 'checked', null, row);
                        var transactionId = getElementValueSafe('td.transaction-id-wrapper input[type=text]', 'value', null, row);

                        postData.Payments.push({
                            PaymentId: paymentId,
                            PaymentState: state,
                            IsActive: isActive,
                            TransactionId: transactionId
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            postData.OrderItems = processOrderItems('.admin-order-items tr.admin-item-row');
            postData.OrderFreeItems = processOrderItems('.admin-order-free-items tr.admin-item-row');
            postData.Gifts = processOrderItems('.admin-order-gifts tr.admin-item-row');
            postData.NewPayment = gatherNewPayment();

            orderPaymentService.saveOrderAdminDetail(postData).done(function (result) {
                window.location.reload();
            }).fail(function (err) {
                showError(err);
            });
        } catch (e) {
            showError(e.message);
        }
    }

    function processOrderItems(selector) {
        var rows = document.querySelectorAll(selector);
        if (rows.length < 1) return null;

        var items = [];

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var itemRow = _step2.value;

                var id = getElementIntValueSafe('.admin-order-item-id', 'value', itemRow);
                if (!id || id < 1) continue;

                var state = getElementIntValueSafe('.admin-item-new-state select', 'value', itemRow);
                var cancelAccepted = getElementIntValueSafe('.admin-item-cancel-accepted input[type=checkbox]', 'value', itemRow);

                items.push({ OrderItemId: id, OrderItemState: state, CancelAccepted: cancelAccepted });
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return items;
    }

    function gatherNewPayment() {
        var transactionId = getElementValueSafe('.admin-order-detail #newPaymentTransactionId');
        if (!transactionId) return null;

        var paymentIdentifier = getElementValueSafe('.admin-order-detail #newPaymentPaymentIdentifier');
        var payerId = getElementValueSafe('.admin-order-detail #newPaymentPaymentPayerId');
        var price = getElementValueSafe('.admin-order-detail #newPaymentPaymentPrice');
        var method = getElementValueSafe('.admin-order-detail #newPaymentPaymentMethod');

        return {
            TransactionId: transactionId,
            Identifier: paymentIdentifier,
            PayerId: payerId,
            Price: price,
            Method: method
        };
    }

    function getElementIntValueSafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var baseElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

        var strValue = getElementValueSafe(selector, propertyName, '0', baseElement);

        if (!/^[0-9]+$/.test(strValue)) return 0;

        return parseInt(strValue);
    }

    function getElementValueSafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var defValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var baseElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;

        if (!baseElement) baseElement = document;
        var element = baseElement.querySelector(selector);
        if (!element) return defValue;

        return element[propertyName] === undefined || element[propertyName] === null ? defValue : element[propertyName];
    }

    function showError(message) {
        sweetAlert({
            type: 'error',
            title: Resx.Common.AjaxError,
            text: message,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: Resx.Common.OK
        });
    }
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common');
var orderPaymentService = abp.services.api.orderPayment;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/adminOrderDetail.js
// module id = 407
// module chunks = 0